import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useI18n } from 'circe/I18n/provider';
import LanguageSwitcherMenu from './LanguageSwitcherMenu';
import LanguageSwitcherInline from './LanguageSwitcherInline';

const LanguageSwitcher = ({ theme, ...props }) => {
  const i18n = useI18n();
  useEffect(() => {
    localStorage.setItem('localeForApi', i18n.locale?.key || 'ar');
  }, []);
  switch (theme) {
    case 'inline':
      return <LanguageSwitcherInline key="LanguageSwitcherInline" {...props} {...i18n} />;

    case 'menu':
    default:
      return <LanguageSwitcherMenu key="LanguageSwitcherMenu" {...props} {...i18n} />;
  }
};

LanguageSwitcher.defaultProps = {
  theme: 'menu',
};

LanguageSwitcher.propTypes = {
  theme: PropTypes.oneOf(['menu', 'inline']),
};

export default LanguageSwitcher;
